'use client';

import React from 'react';
import { motion } from 'framer-motion';
import InfoBlock from './InfoBlock';
import RandomText from './RandomText';
import { Service2 } from '@/lib/strapi';

interface Props {
  data: Service2 | null;
  lang: string;
}

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
    },
  },
};

export default function ServicesGrid({ data, lang }: Props) {
  const services = data?.Service || [];
  
  if (services.length === 0) return null;

  return (
    <section className="py-24 bg-white px-6 overflow-hidden min-h-[600px] border-t border-slate-100">
      <div className="max-w-7xl mx-auto">
        {/* Заголовок секции (как в AboutTilesSection) */}
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mb-20 text-center"
        >
          <h2 className="text-4xl md:text-6xl font-black text-slate-900 mb-6 tracking-tighter">
            <RandomText text={data?.ServiceSEO?.HomeBlockTtitle || (lang === 'ru' ? 'Наши услуги' : 'Our Services')} />
          </h2>
          <div className="w-24 h-1.5 bg-blue-600 mx-auto rounded-full mb-8" />
          {data?.ServiceSEO?.Slogan && (
            <p className="text-xl text-slate-500 max-w-2xl mx-auto font-light">
              <RandomText text={data.ServiceSEO.Slogan} delay={0.2} />
            </p>
          )}
        </motion.div>
        
        {/* Сетка (2x2 как просил пользователь) */}
        <motion.div 
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
          className="grid grid-cols-1 md:grid-cols-2 gap-10"
        >
          {services.slice(0, 4).map((service, idx) => (
            <InfoBlock 
              key={service.id} 
              data={service} 
              mode="summary" 
              index={idx} 
              lang={lang}
              basePath="services"
            />
          ))}
        </motion.div>
      </div>
    </section>
  );
}
